module.exports = __webpack_public_path__ + "img/icon_9.a37974ed.png";